import { EProcessNames } from "api/enums";
import AttachmentsMeasurement from "components/Attachments/AttachmentsMeasurement";
import MeasurementImportFromFile from "components/Importation/MeasurementImportFromFile";
import MeasurementReadjustment from "components/Measurement/MeasurementReadjustment";
import { AccessProfileStore, MessageStore } from "store";
import { lang } from "../../../i18nLang";
import AdvanceLink from "../../Advances/AdvanceLink";
import SendToBilling from "../../Billing/SendToBilling";
import DiscountLink from "../../Discounts/DiscountLink";
import MeasurementDelete from "../../Measurement/MeasurementDelete";
import { MenuLabel, SimpleMenu } from "../../UI/Menus";
import Export from "../Export/Export";
import ModalMenuItem from "./ModalMenuItem";

const MeasurementMenu = (props: {
  anchorEl: Element | null;
  onClose: () => void;
}) => {
  const handleClickMenu = (ev) => {
    const exportLabel = lang(`project.menu.settingsMeasurement.export`);
    if (ev.target.innerText !== exportLabel) {
      props.onClose();
    }
  };

  const validateAccessMenu = () => {
    if (
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.GERAR_MEDICOES
      )
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return false;
    }
    return true;
  };

  const validateCanDelete = () => {
    if (
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.EXCLUIR_MEDICOES
      )
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return false;
    }
    return true;
  };

  const validateSendToBilling = () => {
    if (
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.CRIAR_DOC_VENDA
      )
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return false;
    }
    return true;
  };

  return (
    <SimpleMenu
      anchorEl={props.anchorEl}
      keepMounted
      open={Boolean(props.anchorEl)}
      onClose={props.onClose}
      onClick={handleClickMenu}
    >
      {/* Pârametro */}
      <MenuLabel variant="body1" noWrap>
        {lang(`project.menu.parameters.title`)}
      </MenuLabel>
      <ModalMenuItem
        title={lang(`project.menu.parameters.advances`)}
        Component={AdvanceLink}
        onBeforeOpen={validateAccessMenu}
      />
      <ModalMenuItem
        title={lang(`project.menu.parameters.discounts`)}
        Component={DiscountLink}
        onBeforeOpen={validateAccessMenu}
      />
      <ModalMenuItem
        title={lang(`project.menu.parameters.measurementReadjustment`)}
        Component={MeasurementReadjustment}
        onBeforeOpen={validateAccessMenu}
      />
      {/* <MenuItem onClick={() => {}}>{lang(`project.menu.parameters.taxes`)}</MenuItem> */}
      {/* <MenuItem onClick={() => {}}>{lang(`project.menu.parameters.retention`)}</MenuItem> */}

      {/* Configurações da medição */}
      <MenuLabel variant="body1" noWrap>
        {lang(`project.menu.settingsMeasurement.title`)}
      </MenuLabel>
      <ModalMenuItem
        title={lang(`project.menu.settingsMeasurement.import`)}
        Component={MeasurementImportFromFile}
        onBeforeOpen={validateAccessMenu}
      />
      <ModalMenuItem
        title={lang(`project.menu.settingsMeasurement.attachFiles`)}
        Component={AttachmentsMeasurement}
      />
      {/* <ModalMenuItem
          title={lang(`project.menu.settingsMeasurement.recalculate`)}
          Component={MeasurementRecalculate}
          onBeforeOpen={validateAccessMenu}
        ></ModalMenuItem> */}
      <ModalMenuItem
        title={lang(`project.menu.settingsMeasurement.sendToBilling`)}
        Component={SendToBilling}
        onBeforeOpen={validateSendToBilling}
      ></ModalMenuItem>
      <ModalMenuItem
        title={lang(`project.menu.settingsMeasurement.delete`)}
        Component={MeasurementDelete}
        onBeforeOpen={validateCanDelete}
      ></ModalMenuItem>
      <ModalMenuItem
        title={lang(`project.menu.settingsMeasurement.export`)}
        Component={Export}
      ></ModalMenuItem>
      {/* <MenuItem onClick={() => {}}>{lang(`project.menu.settingsMeasurement.occurrences`)}</MenuItem> */}
    </SimpleMenu>
  );
};

export default MeasurementMenu;
